// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__13Qt0","buttons":"SendReceipts_buttons__nRdlK","email":"SendReceipts_email__39-C2","bookApptTitle":"SendReceipts_bookApptTitle__2vCPb"};